import { render, staticRenderFns } from "./CheckoutSalon.vue?vue&type=template&id=0bcaf868&scoped=true"
import script from "./CheckoutSalon.vue?vue&type=script&lang=ts"
export * from "./CheckoutSalon.vue?vue&type=script&lang=ts"
import style0 from "./CheckoutSalon.vue?vue&type=style&index=0&id=0bcaf868&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcaf868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcaf868')) {
      api.createRecord('0bcaf868', component.options)
    } else {
      api.reload('0bcaf868', component.options)
    }
    module.hot.accept("./CheckoutSalon.vue?vue&type=template&id=0bcaf868&scoped=true", function () {
      api.rerender('0bcaf868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/CheckoutSalon.vue"
export default component.exports